import style from "css/mobile/menu.module.css";

function AlarmCardCircle({ circleColor, icon }) {
    return (
        <div className={style.alert_circle} style={{ backgroundColor: `${circleColor}` }}>
            {icon}
        </div>
    )
}

export default AlarmCardCircle
